@let screeningRoomActivated = screeningRoomService.activated$ | async;
<!-- TODO: Remove when Lux Award is finished -->

@if (routeHasBeenAnalyzed) {
  @if (screeningRoomActivated) {
    <fspro-header-lux></fspro-header-lux>
  } @else {
    <fspro-header></fspro-header>
  }
  <ng-container [ngSwitch]="type$ | async">
    <fspro-not-found *ngSwitchCase="pageType.NotFound"></fspro-not-found>
    <fspro-forbidden *ngSwitchCase="pageType.Forbidden"></fspro-forbidden>
    <fspro-playback-error *ngSwitchCase="pageType.PlaybackError"></fspro-playback-error>
    <div class="main-content" [ngClass]="{'screening-room': screeningRoomActivated}" role="main">
      <router-outlet *ngSwitchDefault ></router-outlet>
    </div>
  </ng-container>
  <!-- TODO: Remove when Lux Award is finished -->
  @if (screeningRoomActivated) {
    <fspro-footer-lux></fspro-footer-lux>
  } @else {
    <fspro-footer></fspro-footer>
  }
}
